module.exports = __webpack_public_path__ + "static/media/piotech.0016f239.jpeg";